var prodcat = prodcat || {};

prodcat.ui = prodcat.ui || {};
prodcat.data = prodcat.data || {};
var site = site || {};

(function ($) {
  $(document).on('product.skuSelect', '.js-product', function (e, skuBaseId) {
    var $product = $(this);
    var skuData = prodcat.data.getSku(skuBaseId);

    if (!_.isNull(skuData)) {
      var ingredients = skuData.ILN_LISTING;
      var $ilnSection = $product.find('.js-product-starter-kit__data-section--iln');
      var $ilnData = $ilnSection.find('.js-product-starter-kit-iln-listing');

      if ($ilnSection.length >= 1 && ingredients) {
        $ilnSection.show(); // section wrapper restore
        if ($ilnData.length) {
          $ilnData.html(ingredients);
        }
      } else {
        $ilnSection.hide(); // section wrapper hide if sku is missing ingredients
      }
    }
  });

  $(document).on('product:quickshop:available', function () {
    Drupal.behaviors.productStarterKitsV1.attached = false;
    Drupal.behaviors.productStarterKitsV1.attach($(this));
  });

  Drupal.behaviors.productStarterKitsV1 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var $template = $('.js-starter-kit-v1', context);
      var $expanderSections = $('.product-starter-kit__data-section', $template);

      // section expanders
      if ($expanderSections.length) {
        $expanderSections.each(function () {
          var $this = $(this);
          var $trigger = $this.find('.product-starter-kit__data-heading');
          var callback = function (event, el) {
            var $this = el ? $(el) : $(this);
            var $icon = $this.find('.js-product-starter-kit-data-heading-toggle');

            $icon.toggleClass('active');
            var $content = $this.next('.product-starter-kit__data-content');
            // Cast the expanded state as a boolean
            var expanded = $this.attr('aria-expanded') === 'false' ? false : true;

            // Switch the states of aria-expanded and aria-hidden
            $this.attr('aria-expanded', !expanded);
            $content.attr('aria-hidden', expanded);
          };

          // click handler
          $trigger.on('click', callback).on('keydown', function (e) {
            var key = site.getKeycode(e);

            if (key === 13) { // Enter
              e.preventDefault();
              callback(e, this);
            }
          });
        });
      }
    },
    attached: false
  };
})(jQuery);
